export const setApprovalId = (approvalId) =>{
    return{
        type:'SET_APPROVAL_ID',
        value:approvalId
    }
};